import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

export const createUnitActivation = async (model: IActivationServiceRequestModel): Promise<IActivationServiceRequestModel> =>
  axios.post(`/UnitActivation/addunitactivationrequest`, model).then((res) => res?.data?.data)

type Props = {
  model: IActivationServiceRequestModel
}

export const useCreateUnitActivation = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestModel) => void) =>
  useMutation({
    mutationKey: ['createUnitActivation'],
    mutationFn: ({ model }: Props) => createUnitActivation(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created device activation.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create device activation, please try again.')
      }
    },
    throwOnError: false
  })
